<mat-toolbar color="primary">
  <mat-toolbar-row class="menu-toolbar">
    <a fxShow="true" fxHide.gt-md href="https://www.restoreunited.com">
      <img [src]="srcLogo" class="logo item-toolbar" />
    </a>
    <div
      class="item-toolbar"
      fxShow="true"
      fxHide.lt-lg
      class="item-toolbar"
      style="width: 100%"
    >
      <div style="display: flex; width: 100%">
        <a href="https://www.restoreunited.com">
          <img [src]="srcLogo" class="logo item-toolbar" />
        </a>
        <span class="menu-spacer item-toolbar"></span>
        <!-- The following menu items will be hidden on both SM and XS screen sizes -->
        <ul class="nav menu">
          <li>
            <a class="menu-link" href="https://www.restoreunited.com/">
              Home
            </a>
          </li>
          <li>
            <a
              class="menu-link"
              href="https://www.restoreunited.com/why-restoreunited/"
            >
              Why RestoreUnited
            </a>
          </li>
          <li>
            <a class="menu-link" href="https://www.restoreunited.com/features/">
              Features
            </a>
          </li>
          <li>
            <a
              class="menu-link"
              href="https://www.restoreunited.com/benchmarks/"
            >
              Benchmarks
            </a>
          </li>
          <li>
            <a
              class="menu-link"
              href="https://www.restoreunited.com/contact-us/"
            >
              Contact Us
            </a>
          </li>
          <li>
            <a class="menu-link" style="color: #ed1e24" routerLink="/pricing">
              Sign Up
            </a>
          </li>
          <li class="phone-menu">
            <a href="tel:8002001104">800-200-1104</a>
          </li>
        </ul>
      </div>
    </div>

    <span class="example-spacer"></span>
    <div class="group-button" fxShow="true" fxHide.gt-md>
      <a href="tel:8002001104">
        <fa-icon
          [icon]="faPhoneSquareAlt"
          style="color: #bc4630; vertical-align: text-top; font-size: 30px"
        ></fa-icon>
      </a>

      <button
        mat-icon-button
        (click)="openNav()"
        [autofocus]="false"
        class="menu-btn"
      >
        <mat-icon class="mat-icon">menu</mat-icon>
      </button>
    </div>
  </mat-toolbar-row>
</mat-toolbar>

<div id="mySidenav" class="sidenav">
  <button
    class="closebtn"
    mat-icon-button
    (click)="closeNav()"
    [autofocus]="false"
  >
    <mat-icon class="mat-icon">clear</mat-icon>
  </button>
  <div class="navbar-wrapper clearfix">
    <div class="social-widget"></div>
    <nav
      id="main-nav-wrap"
      itemscope="itemscope"
      itemtype="https://schema.org/SiteNavigationElement"
    >
      <ul id="main-nav" class="main-nav menu-name-main-nav with-sub-arrow">
        <li>
          <a class="menu-link" href="https://www.restoreunited.com/"> Home </a>
        </li>
        <li>
          <a
            class="menu-link"
            href="https://www.restoreunited.com/why-restoreunited/"
          >
            Why RestoreUnited
          </a>
        </li>
        <li>
          <a class="menu-link" href="https://www.restoreunited.com/features/">
            Features
          </a>
        </li>
        <li>
          <a class="menu-link" href="https://www.restoreunited.com/benchmarks/">
            Benchmarks
          </a>
        </li>
        <li>
          <a class="menu-link" href="https://www.restoreunited.com/contact-us/">
            Contact Us
          </a>
        </li>
        <li>
          <a class="menu-link" routerLink="/pricing"> Sign Up </a>
        </li>
        <li class="">
          <a style="color: #bc4630" href="tel:8002001104">800-200-1104</a>
        </li>
      </ul>
      <!-- /#main-nav -->
    </nav>
    <!-- /#main-nav-wrap -->
  </div>
</div>
<div id="wrapperOver" class="wrapperOver" style="display: none"></div>
<div id="main">
  <div class="margin-container-reponsive">
    <div class="title-body">
      <h4>Thank you for choosing RestoreUnited</h4>
    </div>
    <div class="row">
      <div class="col-md-7">
        <form [formGroup]="signUpForm" (ngSubmit)="onSubmit()">
          <div class="accordion" id="accordion-example">
            <div id="collapse-one" class="collapse-one cursor-pointer">
              <div class="collapse-header collapse-header-one">
                <span class="step-signup active" (click)="onToggleStep(1)">
                  <span class="step-number">1</span>
                  <span class="step-name">Let's set up your account</span>
                </span>
              </div>
              <div
                class="collapse-body collapse collapse-body-one"
                [ngClass]="{ show: isShowStepOne }"
              >
                <div class="form-group">
                  <label>
                    Enter your email address, we’ll create an account for you.
                  </label>
                  <div>
                    <input
                      type="text"
                      id="ipSignUpEmail"
                      placeholder="Enter your email address"
                      formControlName="email"
                      class="form-control"
                      [ngClass]="{
                        'is-invalid': submittedOne && f.email.errors,
                      }"
                    />
                    <mat-error
                      *ngIf="f.email.touched && f.email.errors?.required"
                    >
                      Email is required
                    </mat-error>
                    <mat-error *ngIf="f.email.errors?.email">
                      Email must be a valid email address
                    </mat-error>
                    <mat-error *ngIf="f.email.touched && isUserEmailExist">
                      Email already exists!
                    </mat-error>
                  </div>
                </div>
                <button
                  type="button"
                  class="btn btn-signup-next btn-next-one"
                  (click)="onCheckvalidateStep1()"
                  [disabled]="!isDisabledOne || isValidatingEmail()"
                >
                  <span *ngIf="!isValidatingEmail()">Next</span>
                  <span *ngIf="isValidatingEmail()">Validating...</span>
                </button>
              </div>
            </div>
            <div
              id="collapse-tow"
              class="collapse-tow collapse-step cursor-pointer"
            >
              <div class="collapse-header collapse-header-tow">
                <span
                  class="step-signup"
                  (click)="onToggleStep(2)"
                  [ngClass]="{
                    active: isActiveTwo || isRedirect,
                  }"
                >
                  <span class="step-number">2</span>
                  <span class="step-name">Tell us about yourself</span>
                </span>
              </div>
              <div
                class="collapse-body collapse collapse-body-tow"
                [ngClass]="{ show: isShowStepTwo }"
              >
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <input
                        type="text"
                        id="ipSignUpFirstName"
                        placeholder="First Name"
                        formControlName="firstName"
                        (input)="onChangeInputTow($event)"
                        class="form-control"
                        [ngClass]="{
                          'is-invalid': submittedTwo && f.firstName.errors,
                        }"
                      />
                      <mat-error
                        *ngIf="
                          f.firstName.touched && f.firstName.errors?.required
                        "
                      >
                        First Name is required
                      </mat-error>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <input
                        type="text"
                        id="ipSignUpLastName"
                        placeholder="Last Name"
                        formControlName="lastName"
                        (input)="onChangeInputTow($event)"
                        class="form-control"
                        [ngClass]="{
                          'is-invalid': submittedTwo && f.lastName.errors,
                        }"
                      />
                      <mat-error
                        *ngIf="
                          f.lastName.touched && f.lastName.errors?.required
                        "
                      >
                        Last Name is required
                      </mat-error>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <input
                        type="text"
                        id="ipSignUpPhoneNo"
                        placeholder="Phone Number"
                        formControlName="phoneNumber"
                        (input)="onChangeInputTow($event)"
                        class="form-control"
                        [ngClass]="{
                          'is-invalid': submittedTwo && f.phoneNumber.errors,
                        }"
                      />
                      <mat-error
                        *ngIf="
                          f.phoneNumber.touched &&
                          f.phoneNumber.errors?.required
                        "
                      >
                        Phone Number is required
                      </mat-error>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <select
                        id="ipSignUpCountry"
                        formControlName="country"
                        (change)="onChangeInputTow($event)"
                        class="form-control"
                        [ngClass]="{
                          'is-invalid': submittedTwo && f.country.errors,
                        }"
                      >
                        <option value="" disabled selected>
                          Select Country or Region
                        </option>
                        <option
                          *ngFor="let country of allCountry"
                          [value]="country.code"
                        >
                          {{ country.name }}
                        </option>
                      </select>
                      <mat-error
                        *ngIf="f.country.touched && f.country.errors?.required"
                      >
                        Country or Region is required
                      </mat-error>
                    </div>
                  </div>
                </div>
                <!-- <div style="margin: 2px 0 20px 0">Tell us about your business.</div> -->
                <div class="">
                  <div class="form-group">
                    <input
                      type="text"
                      id="ipSignUpCompanyName"
                      placeholder="Company Name"
                      formControlName="companyName"
                      (input)="onChangeInputTow($event)"
                      (change)="onChangeCompanyName()"
                      class="form-control"
                      [ngClass]="{
                        'is-invalid': submittedTwo && f.companyName.errors,
                      }"
                    />
                    <mat-error
                      *ngIf="
                        f.companyName.touched && f.companyName.errors?.required
                      "
                    >
                      Company Name is required
                    </mat-error>
                  </div>
                </div>
                <button
                  type="button"
                  class="btn btn-signup-next btn-next-one"
                  (click)="onNextStep(2)"
                  [disabled]="!isDisabledTwo"
                >
                  Next
                </button>
              </div>
            </div>
            <div
              id="collapse-tow"
              class="collapse-tow collapse-step cursor-pointer"
            >
              <div class="collapse-header collapse-header-tow">
                <span
                  class="step-signup"
                  (click)="onToggleStep(23)"
                  [ngClass]="{
                    active: isActiveCoupon || isRedirect,
                  }"
                >
                  <span class="step-number">3</span>
                  <span class="step-name">How did your hear about us?</span>
                </span>
              </div>
              <div
                class="collapse-body collapse collapse-body-tow"
                [ngClass]="{ show: isShowStepCoupon }"
              >
                <!-- <div style="margin: 2px 0 20px 0">How did you find out about RestoreUnited?</div> -->
                <div class="">
                  <div class="form-group">
                    <input
                      type="text"
                      placeholder="Type Your Response"
                      formControlName="aboutus"
                      class="form-control"
                    />
                    <mat-error
                      *ngIf="f.aboutus.touched && f.aboutus.errors?.maxlength"
                    >
                      Character limit exceed. Response can contains up to 30
                      characters.
                    </mat-error>
                  </div>
                </div>
                <div style="margin: 20px 0 10px 0">Promo Code</div>
                <div class="form-group">
                  <input
                    type="text"
                    id="idCoupon"
                    placeholder="Enter Code"
                    formControlName="coupon"
                    class="form-control"
                  />
                </div>
                <button
                  type="button"
                  class="btn btn-signup-next btn-next-one"
                  (click)="onNextStep(23)"
                  [disabled]="!isDisabledOne || !isDisabledTwo"
                >
                  Next
                </button>
              </div>
            </div>
            <div
              id="collapse-three"
              class="collapse-three collapse-step cursor-pointer"
            >
              <div class="collapse-header collapse-header-three">
                <span
                  class="step-signup"
                  (click)="onToggleStep(3)"
                  [ngClass]="{
                    active: isActiveThree || isRedirect,
                  }"
                >
                  <span class="step-number">4</span>
                  <span class="step-name">Subscription & Payment</span>
                </span>
              </div>
              <div
                class="collapse-body collapse collapse-body-three"
                [ngClass]="{ show: isShowStepThree }"
              >
                <div
                  class="divAgreement divContentThree"
                  [ngClass]="{ show: isShowStepThree1 }"
                >
                  <h6 style="color: #41404d">
                    No Term Contract, Cancel Anytime!
                  </h6>
                  <div class="divAgreementContent" (scroll)="onScroll($event)">
                    <h6>
                      RestoreUnited Software Service Subscription Agreement
                    </h6>
                    <p>
                      PLEASE CAREFULLY REVIEW THE FOLLOWING END-USER LICENSE
                      AGREEMENT OF RESTOREUNITED, A WHOLLY-OWNED SUBSIDIARY OF
                      SR SOLUTIONS, INC. (HEREINAFTER “RU”), ANY AND ALL TERMS
                      OF USE THAT REFERENCE THIS AGREEMENT (HEREINAFTER
                      “AGREEMENT”). THIS AGREEMENT IS A LEGALLY BINDING CONTRACT
                      BETWEEN SUBSCRIBER AND RU (AS DEFINED BELOW). THIS
                      AGREEMENT EXPRESSLY INCORPORATES ANY AND ALL TERMS OF USE
                      THAT REFERENCE THIS AGREEMENT. THIS AGREEMENT GOVERNS ALL
                      USE OF RU'S SERVICES, SOFTWARE AND ANY ASSOCIATED
                      DOCUMENTATION, BOTH ONLINE AND OFFLINE. BY CLICKING “I
                      AGREE’ OR OTHERWISE USING THE SOFTWARE OR SERVICES,
                      SUBSCRIBER CONSENTS TO ALL OF THE TERMS AND CONDITIONS SET
                      FORTH IN THIS AGREEMENT. IF SUBSCRIBER DOES NOT AGREE TO
                      ANY OF THE TERMS OF THIS AGREEMENT, SUBSCRIBER SHALL
                      IMMEDIATELY STOP USING THE SERVICES AND / OR SOFTWARE. IN
                      THE EVENT OF ANY CONFLICT BETWEEN THIS AGREEMENT AND ANY
                      TERMS OF USE, THE TERMS OF THIS AGREEMENT SHALL PREVAIL
                      AND CONTROL. RU may modify the terms of this Agreement
                      from time to time and shall post the most current version
                      at www.restoreunited.com; either express or implied, made
                      by any person or contained within any materials supplied
                      by RU, the provisions of this Agreement shall prevail. All
                      prices and terms are subject to change and RU reserves the
                      right to increase Licensee’s Monthly Subscription Fee rate
                      at anytime without notice. This Agreement shall be
                      governed by and construed in accordance with the laws of
                      the Commonwealth of Pennsylvania. If any provision of this
                      Agreement is held by a court of competent jurisdiction to
                      be illegal, invalid or unenforceable then the provision
                      shall be severed and the other provisions shall remain in
                      full force and effect. Venue for any cause of action
                      arising under or in connection with this Agreement shall
                      be York County, Pennsylvania. Licensee’s acceptance of
                      this Agreement constitutes express written consent for RU
                      to send information to Licensee or Licensee’s designee for
                      any purpose via facsimile transmission or by text
                      messaging to any wireless device number that Licensee or
                      Licensee’s designee provides to RU, and constitutes
                      express written consent for RU to contact Licensee or
                      Licensee’s designee via telephone or electronic mail, or
                      via any wireless telephone number that Licensee or
                      Licensee’s designee provides to RU. Failure by RU to
                      exercise any of its rights under this Agreement shall not
                      be construed as to waive RU’s ability to exercise such
                      rights thereafter.
                    </p>
                  </div>

                  <div class="row agree-row">
                    <div class="col-md-9 agree-text">
                      <!-- You will be directed to Stripe Payment Gate after clicking "I Agree" -->
                    </div>
                    <div class="col-md-3">
                      <button
                        type="button"
                        class="btn btn-signup-next btn-next-one agree-button"
                        [disabled]="!isDisabledThree"
                        (click)="createPaymentSession()"
                      >
                        I Agree
                      </button>
                    </div>
                  </div>
                </div>
                <div
                  class="divCasts divContentThree"
                  [ngClass]="{ show: isShowStepThree2 }"
                >
                  <div>
                    <i class="material-icons" style="color: #bc4630">
                      check_circle
                    </i>
                    <i
                      class="material-icons"
                      style="margin-left: 34px; color: #bc4630"
                    >
                      check_circle
                    </i>
                  </div>
                  <div>
                    <p>
                      <strong>Thank you for your subscription. </strong>
                    </p>
                    <p>
                      We will send your administrator password to your email
                      address
                      <strong>{{ f['email'].value }}.</strong>
                    </p>
                    <p>
                      If you have not received your password or have any
                      questions about your subscription, you can email us at
                      <span style="color: #3e92cc; font-weight: bolder"
                        >support@restoreunited.com</span
                      >
                      <br />
                      or call us
                      <span style="color: #3e92cc; font-weight: bolder"
                        >(+1) (800) 200-1104.</span
                      >
                    </p>
                    <div style="text-align: right">
                      <button
                        type="button"
                        class="btn btn-signup-next btn-next-four"
                        (click)="onPayment()"
                      >
                        Proceed to payment
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="collapse-four" class="collapse-four collapse-step">
              <div class="collapse-header collapse-header-four cursor-pointer">
                <span class="step-signup" [ngClass]="{ active: isActiveFour }">
                  <span class="step-number">5</span>
                  <span class="step-name">Confirmation</span>
                </span>
              </div>
              <div
                class="collapse-body collapse collapse-body-four"
                [ngClass]="{ show: isShowStepFour }"
              >
                <p>
                  <strong>Thank you for your subscription. </strong>
                </p>
                <p>
                  We will send your administrator password to your email address
                  <strong>{{ f['email'].value }}</strong
                  >.
                </p>
                <p>
                  If you have not received your password or have any questions
                  about your subscription, please email us at
                  <span style="color: #3e92cc; font-weight: bolder"
                    >support@restoreunited.com</span
                  >
                  <br />
                  or call us
                  <span style="color: #3e92cc; font-weight: bolder"
                    >(800) 200-1104.</span
                  >
                </p>
                <div style="text-align: right">
                  <button
                    type="button"
                    class="btn btn-signup-next btn-next-four"
                    (click)="onBackHome()"
                  >
                    Return Home
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="col-md-5">
        <div *ngIf="product()" class="divRightContent">
          <div
            class="divUserProfile"
            style="text-align: center; position: relative"
          >
            <p class="title-plan">{{ product()?.Name_Plan }}</p>
            <img
              src="../../../assets/image/YourEnterprisePlan.png"
              [alt]="product()?.Name_Plan"
              width="300px"
              height="300px"
            />
          </div>
          <div
            style="text-align: center; width: 100%; height: 80px"
            *ngIf="product() && product()?.Name_Plan != 'Professional'"
          >
            <div *ngIf="product() && product()?.Name_Plan != 'Advanced'">
              <!-- <h4 class="price">{{product?.Price | currency}}</h4> -->
              <div class="row">
                <!-- <div class="col-4 introduce-rate-title" [ngClass]="(product && product.IsDeleted == true) ? 'text-decoration' : ''" style="text-align: right;">
                                    <div>Introductory</div>
                                    <div>Rate</div>
                                </div> -->
                <div class="col-4"></div>
                <div
                  class="col-8"
                  style="text-align: left; color: #bc4630; padding: 0"
                >
                  <span
                    style="
                      font-weight: bold;
                      font-size: 36px;
                      line-height: 43px;
                    "
                    [ngClass]="
                      product() && product()?.IsDeleted == true
                        ? 'text-decoration'
                        : ''
                    "
                  >
                    {{
                      product()?.Price_Sale | currency: 'USD' : 'symbol' : '0.0-1'
                    }}
                    /
                  </span>
                  <span
                    [ngClass]="
                      product() && product()?.IsDeleted == true
                        ? 'text-decoration'
                        : ''
                    "
                  >
                    month</span
                  >
                </div>
              </div>
            </div>
            <div *ngIf="product() && product()?.Name_Plan == 'Advanced'">
              <div style="text-align: center; padding: 0 30px">
                We have the
                <span style="color: #bc4630">solution</span> for everyone. Get
                in touch with us for a custom quote
              </div>
            </div>
          </div>

          <div
            style="text-align: center; width: 100%; height: 80px"
            *ngIf="product() && product()?.IsDeleted == true"
          >
            <div>
              <div class="row">
                <div
                  class="col-4 introduce-rate-title"
                  style="text-align: right"
                >
                  <div>ICAN Member's</div>
                  <div>Rate</div>
                </div>

                <div
                  class="col-8"
                  style="text-align: left; color: #bc4630; padding: 0"
                >
                  <span
                    *ngIf="product() && product()?.Name_Plan == 'Professional'"
                    style="
                      font-weight: bold;
                      font-size: 36px;
                      line-height: 43px;
                    "
                  >
                    {{ 495 | currency: 'USD' : 'symbol' : '0.0-1' }} /
                  </span>
                  <span
                    *ngIf="product() && product()?.Name_Plan == 'Enterprise'"
                    style="
                      font-weight: bold;
                      font-size: 36px;
                      line-height: 43px;
                    "
                  >
                    {{ 995 | currency: 'USD' : 'symbol' : '0.0-1' }} /
                  </span>
                  <span> month</span>
                </div>
              </div>
            </div>
          </div>

          <div style="text-align: center; padding-bottom: 20px">
            <div class="row padding10" *ngIf="product()">
              <div class="col-3" style="text-align: right">
                <mat-icon color="errors">done</mat-icon>
              </div>
              <div class="col-9" style="text-align: left">
                <span
                  *ngIf="
                    product()?.Name_Plan == 'Professional' ||
                    product()?.Name_Plan == 'Enterprise'
                  "
                >
                  Up to {{ product()?.Number_User }} Users
                </span>
                <span
                  *ngIf="
                    product()?.Name_Plan != 'Professional' &&
                    product()?.Name_Plan !== 'Enterprise'
                  "
                >
                  Over {{ product()?.Number_User }} Users
                </span>
              </div>
            </div>
            <div class="row padding10" *ngFor="let benefit of product()?.Benefit">
              <div class="col-3" style="text-align: right">
                <mat-icon color="errors">done</mat-icon>
              </div>
              <div class="col-9" style="text-align: left">
                {{ benefit }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="divFooter">
  <span style="color: #bc4630"> Privacy Policy </span>
  <span class="clsBoder" style="color: #bc4630"> Terms & Conditions </span>
  <span style="color: #41404d">
    Copyright 2020 RestoreUnited. All rights reserved.
  </span>
</div>
